import React, { useEffect, useState } from 'react'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { getSPDataWithParams } from 'src/supportPortal/services/services'

export default function useSupportReportsViewer({ bookedEventSlug }) {
  const [auxiliaryData, setAuxiliaryData] = useState({})
  const [emrSectionDataList, setEmrSectionDataList] = useState([])
  const [bookedEventInfo, setBookedEventInfo] = useState()
  const [loading, setLoading] = useState(false)
  async function getEventData() {
    const resp = await getSPDataWithParams(
      '/api/secure/cc/support/practitioner-supervisor/booked-slot/details',
      {
        slug: bookedEventSlug,
        'send-auxiliary-data': true,
      },
    )
    if (resp.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const data = getDataMapFromCommonResponse(resp)
        setBookedEventInfo(data?.bookedEvent)
        setEmrSectionDataList(data?.screening__EmrSectionData || data?.emrSectionDataList || data?.emrSectionData || [])
        setAuxiliaryData(data)
      }
    }
  }

  async function setup() {
    setLoading(true)
    await getEventData()
    setLoading(false)
  }

  useEffect(() => {
    setup()
  }, [])

  return {
    auxiliaryData,
    bookedEventInfo,
    emrSectionDataList,
    therapyReportData: auxiliaryData?.therapyReport
      ? {
          report: auxiliaryData?.therapyReport,
          template: auxiliaryData?.therapyReportTemplate,
        }
      : null,
    screeningReportData: auxiliaryData?.screeningReport
      ? { report: auxiliaryData?.screeningReport, template:auxiliaryData?.screeningReportTemplate  }
      : null,
    loading,
  }
}
